import React from 'react';
import PropTypes from 'prop-types';

export default function ExtensionDetailItemStateStyledValue({
  value,
  state = '',
}) {
  return <strong className={`text-capitalize ${state}`}>{value}</strong>;
}

const valueType = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number,
  PropTypes.node,
]);

ExtensionDetailItemStateStyledValue.propTypes = {
  value: valueType.isRequired,
  state: PropTypes.string,
};
